import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import CreatableSelect from 'components/commons/CreatableSelect';
import SearchFilterUtil from 'lib/SearchFilterUtil';

const RpDistanceFilter = function(props) {
    const { options, value, onChange, label, tooltip, active, inputStyle, validateInput, onError, containerStyle, onInputChange } = props;
    const [error, setError] = useState('');

    const validateField = useCallback((value) => {
        const _value = typeof value === 'string' ? value : value?.value;
        if (validateInput) {
            let error = '';

            if (_value !== '' && _value !== undefined) {
                error = validateInput(_value);
            }

            setError(error || '');
            if (onError) {
                onError([error].filter(e => Boolean(e)));
            }
        }
    }, [validateInput, onError]);

    useEffect(() => {
        if (!validateInput) return;
        validateField(value);
    }, [value, validateInput, validateField]);

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            ...containerStyle,
        }}>
            <CreatableSelect
                options={options}
                value={value}
                onChange={(_, newValue) => {
                    validateField(newValue);
                    onChange(newValue);
                }}
                onInputChange={onInputChange}
                label={label || 'Distance'}
                sx={{
                    width: 104,
                }}
                tooltip={tooltip}
                active={!error && active}
                inputStyle={{
                    ...inputStyle,
                    ...(error && {
                        '& .MuiFormLabel-root': {
                            color: '#d32f2f',
                            '&.Mui-focused': {
                                color: '#d32f2f',
                            },
                        },
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused .MuiInputBase-input': {
                                color: 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    }),
                }}
                error={!!error}
                filterOptions={(options, params) => SearchFilterUtil.filterOptions(options, params)}
                isOptionEqualToValue={SearchFilterUtil.isOptionEqualToValue}
            />
            {error && <Typography variant="textError2" sx={{ wordWrap: 'break-word' }}>{error}</Typography>}
        </Box>
    );
};


RpDistanceFilter.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    inputStyle: PropTypes.string,
    validateInput: PropTypes.func,
    onError: PropTypes.func,
    onInputChange: PropTypes.func,
    active: PropTypes.bool,
    containerStyle: PropTypes.object,
};

export default RpDistanceFilter;